// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"zp-z","slideIn":"Ap-z"};